import { render, staticRenderFns } from "./PdvHeader.vue?vue&type=template&id=cc3042c2&scoped=true"
import script from "./PdvHeader.vue?vue&type=script&lang=js"
export * from "./PdvHeader.vue?vue&type=script&lang=js"
import style0 from "./PdvHeader.vue?vue&type=style&index=0&id=cc3042c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3042c2",
  null
  
)

export default component.exports